<template>
	<section :class="`ryoma-page-${$route.name}`">
		<article
			v-if="isDesktopDevice || !standardView">
			<form-config-provider-simple
				target="simple" />
		<FaqComponent />
			
		</article>
		<aside
			v-if="isDesktopDevice || standardView">
			<h3>Contact Us</h3>
			<ul>
				<li>
					Rue de Locht 
					Schaerbeek <br>
					1030, Brussels
				</li>
				<li>
					<a href="tel:+32483553485">+32 483 55 34 85</a>	
				</li>
				<li>
				<a href="mailto:hello@ryoma.eu">hello@ryoma.eu</a>	
				</li>
			</ul>
			<h3>Follow us</h3>
		</aside>

		<!-- <button
		v-if="!isDesktopDevice"
			class="ryoma--switch"
			@click="switchView">SWITCH</button> -->
	</section>
</template>

<script>
import FaqComponent from "@/components/FaqComponent"
import FormConfigProviderSimple from "@/components/form/FormConfigProviderSimple"

export default {
	name: 'contacts',
	data() {
		return {
			standardView: false,
		}
	},
	components: {
		FaqComponent,
		FormConfigProviderSimple
	},
	computed: {
		isDesktopDevice: function() {
			return window.outerWidth > 768;
		}
	},
	methods: {
		switchView: function() {
			this.standardView = !this.standardView
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/_mixins.scss';

	section {

		&[class*='ryoma-page-'] {
			@include grid-padding;

			@include respond-to(tablet) {
				@include grid(12);
			}
			@include respond-to(desktop) {
				min-height: 65vh;
				@include grid(12);
			}
		}

		aside {

			@include respond-to(tablet) {
				grid-column: 2 / span 4;
				grid-row-start: 1;
			}

			@include respond-to(desktop) {
				grid-column: 2 / span 3;

				h3 {
					font-size: 1.125rem;
				}
				ul li {
					font-size: 1.2rem;
				}
			}
		}

		article {

			@include respond-to(tablet) {
				grid-column: 2 / span 10;
			}

			@include respond-to(desktop) {
				grid-column: 5 / span 6;
			}
		}
	}
</style>

